module.exports = __webpack_public_path__ + "img/normal.ad073804.png";